/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgElEQVR4nN2VPUsDQRCGD4kasNZfoI3Y2ikLQuAwmZk94TITCBw214mFVaq0EVv/RGwVtTamtLPXJkGw1Sr4werFj5x37B2XxoEXFnZnnp2d2V3H+Tfm+/4caj4E4iFqecsj0DxALR0TKwYwE3kDY1ydGCCif++GeAjEL5EyZWVi/ZXBjwVyp5QqAfjLRmEYziLxfRZIKgCJu7F54m4xAJJzFQTlyXkVBGUkvpgqADRfTvGI5KSwGpgim8JWdxorRsUX+UP8MG5TM856FywACSK5Ac0hajlCLaOCAXxbqTQXxj6gJUCSa6LGtuc1l1zfX0RPqqClbwt4Rc1P0fgZ0V+d9Gu32zOxjlOqZFODx6pXXzMBgPgYsb4bc/ry5f3oaRkCyV7Col+AEXiylbbLsRHxZlSbUyA+M1nXdGMjFQAkB46lgZaW8XFdd94oavNWKqDm1dctg/eTu417qc+1TY9jlruQ5cNx8gA+v0zp2GTi5AHksekDiHtJwUHLlVn0DsE+imoJtreDAAAAAElFTkSuQmCC)
 */
export const ImageLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v9.15a4.48 4.48 0 0 0-5.93-.06l-.72-.96a2 2 0 0 0-3.2 0L9.93 16.1l-.5-.64a1.5 1.5 0 0 0-2.35 0l-1.86 2.32A.75.75 0 0 0 5.81 19H13v3H5a3 3 0 0 1-3-3V5Zm8.2.98c.23-.91-.88-1.55-1.55-.9a.93.93 0 0 1-1.3 0c-.67-.65-1.78-.01-1.55.9a.93.93 0 0 1-.65 1.12c-.9.26-.9 1.54 0 1.8.48.14.77.63.65 1.12-.23.91.88 1.55 1.55.9a.93.93 0 0 1 1.3 0c.67.65 1.78.01 1.55-.9a.93.93 0 0 1 .65-1.12c.9-.26.9-1.54 0-1.8a.93.93 0 0 1-.65-1.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 18h.5v-.5a2.5 2.5 0 0 1 5 0v.5h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Zm4-.5v.5h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
